import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { CellRange, FlexGrid } from '@grapecity/wijmo.grid';
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { KYMW1422Model } from "./kymw1422.model";
import { GetParentChildPageService } from "./api-services/get-parent-child-page.service";
import { UpdateParentChildDivService } from "./api-services/update-parent-child-div.service";

@Component({
  selector: 'app-kymw1422',
  templateUrl: 'kymw1422.component.html',
  styleUrls: ['kymw1422.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW1422Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('dtg_GoodsList', { static: true }) dtg_GoodsList: FlexGrid;
  @ViewChild('dtg_PageList', { static: true }) dtg_PageList: FlexGrid;
  model = new KYMW1422Model();
  setKYMW1422Parameter: (komaIds: string[]) => void;

  constructor(
    protected kymw00Model: KYMW00Model,
    private getParentChildPageService: GetParentChildPageService,
    private updateParentChildDivService: UpdateParentChildDivService
  ) {
    super(kymw00Model);
  }

  set input(params: {
    orderCode: string,
    mediumType: string,
    coopCode: string,
    komaId: string,
    pageNum: string,
    pageInfo: string,
  }) {
    this.model.koma = { ...params };
  }

  ngOnInit(): void {
    this.componentName = 'KYMW1422';
    this.initGrid();
    if (!this.model.isKomaEmpty()) {
      this.getParentChildPageService.execute(this.model, () => {
        if (this.model.wPublishedGoodsList.length !== 0) {
          this.model.disabledRegister = false;
        }
      });
    }
    
    this.dtg_PageList.hostElement.addEventListener("mouseup", (e: MouseEvent) => {
      const ht = this.dtg_PageList.hitTest(e);
      if ((0 <= ht.row) && (0 == ht.col) && ht.target.className !== 'wj-cell wj-header wj-align-center') {
        document.getElementById(`rb_parent_${ht.row}`).click();
      }
    });
  }

  private initGrid() {
    this.dtg_GoodsList.selectionChanged.addHandler(() => {
      this.eventWPublishedGoodsList_CLICKHandler();
    }
    );
  }

  eventWPublishedGoodsList_CLICKHandler() {
    const rowIndex = this.dtg_GoodsList.selection.row;
    const selectedWPublishedGoods = this.model.wPublishedGoodsList[rowIndex];
    if (!selectedWPublishedGoods) {
      return;
    }

    this.model.wPublishedPageList = selectedWPublishedGoods.wPublishedPages;
    this.model.selectedPageRowIndex =
      this.model.wPublishedPageList.findIndex(page => page.parentChildDiv === '0') ?? -1;
  }

  eventWPublishedPage_CLICKHandler(selectedIndex: number) {
    this.model.wPublishedPageList.map((_, index) => {
      if (index === selectedIndex) {
        this.model.wPublishedPageList[index].parentChildDiv = '0';
      } else {
        this.model.wPublishedPageList[index].parentChildDiv = '1';
      }
    });
  }

  eventRegister_CLICKHandler() {
    this.updateParentChildDivService.execute(this.model, () => {
      const komaIds = this.getKomaIds();
      this.refreshKomas(komaIds);
      this.resetSelectedRow();
    });
  }

  private getKomaIds() {
    const result = this.model.wPublishedGoodsList.map(goods => {
      return goods.wPublishedPages.map(page => page.komaId);
    }).reduce((prev, current) => {
      return [...prev, ...current];
    }, []);
    return result;
  }

  private refreshKomas(komaIds: string[]) {
    if (!!this.setKYMW1422Parameter) {
      this.setKYMW1422Parameter(komaIds);
    }
  }

  private resetSelectedRow() {
    this.dtg_GoodsList.select(new CellRange(0, 0, 0, 0));
  }

}